export default __webpack_public_path__ + "static/media/2254.8cbc9406.png";